module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-contact"
  }, [(_vm.loading) ? _c('Loader') : _vm._e(), (!_vm.loading && _vm.props) ? _c('div', [_c('div', {
    staticClass: "hero-main"
  }, [(_vm.props.acf.hero.bg_video) ? _c('BgVideo', {
    attrs: {
      "props": _vm.props.acf.hero.bg_video
    }
  }) : _vm._e(), _c('div', {
    staticClass: "hero-main__bg",
    style: ({
      backgroundImage: 'url(' + _vm.props.acf.hero.bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "hero-main__title-box"
  }, [_c('div', {
    staticClass: "hero-main__title"
  }, [_c('h2', {
    staticClass: "hero"
  }, [_vm._v(_vm._s(_vm.props.acf.hero.title))]), (_vm.props.acf.hero.button.true && _vm.$route.path !== "/get-started") ? _c('div', {
    staticClass: "hero-main__button",
    on: {
      "click": function($event) {
        _vm.btnFunc(_vm.props.acf.hero.button.func)
      }
    }
  }, [_vm._v(_vm._s(_vm.props.button.text))]) : _vm._e(), (_vm.props.acf.hero.subtitle.true) ? _c('div', {
    staticClass: "hero-main__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.hero.subtitle.text)
    }
  }) : _vm._e()])])])], 1), _c('div', {
    staticClass: "block-intro"
  }, [_c('div', {
    staticClass: "block-title"
  }, [_c('h1', [_vm._v(_vm._s(_vm.props.acf.block_intro.intro.title))])]), (_vm.props.acf.block_intro.intro.text) ? _c('div', {
    staticClass: "block-intro__text",
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.block_intro.intro.text)
    }
  }) : _vm._e()]), _c('CustomContact', {
    attrs: {
      "app": _vm.props.app.acf
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60a683a8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/contact/contact.pug
// module id = 1126
// module chunks = 1